<template>
	<div>
		<canvas ref="myChart"></canvas>
	</div>
</template>

<script>
import { Chart } from "chart.js"
import NisApi from "../api/nis/nis"
import LoadingState from "../consts/LoadingState"

const LABELS = [
	["Governance &", "Risk Management"],
	["Incident Handling", "& Reporting"],
	["Business Continuity", "& Crisis Management"],
	["Supply Chain &", "Third Parties"],
	["Technical &", "Operational Security"],
	["People, Training", "& HR Security"],
]

export default {
	name: "NisScoreTimeline",
	props: {
		yearCount: {
			type: Number,
			default: 2,
		},
	},
	data() {
		return {
			scoreData: [],
			chart: null,
			data: {
				labels: LABELS,
				datasets: [],
			},
			options: {
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								stepSize: 10,
								max: 100,
								callback: function (value) {
									return value + "%"
								},
							},
						},
					],
					xAxes: [
						{
							ticks: {
								autoSkip: false,
								maxRotation: 0,
								minRotation: 0,
								fontSize: 9,
							},
						},
					],
				},
			},
		}
	},
	mounted() {
		this.initDatasets()
		this.initChart()
		this.loadData()
	},
	methods: {
		initDatasets() {
			const colors = [
				"rgba(30, 124, 131, 1)",
				"rgba(222, 143, 24, 1)",
				"rgba(30, 154, 116, 1)",
				"rgba(112, 98, 166, 1)",
				"rgba(91, 107, 140, 1)",
			]
			this.data.datasets = []
			for (let i = 0; i < this.yearCount; i++) {
				this.data.datasets.push({
					label: "",
					data: [0, 0, 0, 0, 0, 0],
					backgroundColor: colors[i % colors.length],
					borderColor: colors[i % colors.length],
					borderWidth: 0.5,
				})
			}
		},
		initChart() {
			this.chart = new Chart(this.$refs.myChart, {
				type: "bar",
				data: this.data,
				options: this.options,
			})
		},
		loadData() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			NisApi.getNisAssessmentsAll()
				.then((result) => {
					const list = Array.isArray(result?.[0]) ? result[0] : result || []
					this.scoreData = list.map((item) => {
						const date = new Date(item.timestamp)
						return {
							year: date.getFullYear(),
							score1: Math.round(item.score1),
							score2: Math.round(item.score2),
							score3: Math.round(item.score3),
							score4: Math.round(item.score4),
							score5: Math.round(item.score5),
							score6: Math.round(item.score6),
						}
					})
					this.updateChart()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		updateChart() {
			if (!this.chart) return
			const sortedData = [...this.scoreData].sort((a, b) => b.year - a.year)
			for (let i = 0; i < this.yearCount; i++) {
				const yearData = sortedData[i] || {
					year: "N/A",
					score1: 0,
					score2: 0,
					score3: 0,
					score4: 0,
					score5: 0,
					score6: 0,
				}
				const datasetIndex = this.yearCount - 1 - i
				this.data.datasets[datasetIndex].label = String(yearData.year)
				this.data.datasets[datasetIndex].data = [
					Math.round(yearData.score1),
					Math.round(yearData.score2),
					Math.round(yearData.score3),
					Math.round(yearData.score4),
					Math.round(yearData.score5),
					Math.round(yearData.score6),
				]
			}
			this.chart.update()
		},
	},
}
</script>
